import React, { useEffect, useState } from "react";
import { USER_TEAM_INDEX } from "../../utils/blindDraft";
import "./DraftOrderReveal.css";

const REVEAL_MS = 550;
const GAP_MS = 200;

function DraftOrderReveal({ draftOrder, teamNames, onBeginDraft, onBack }) {
    const [revealedSlots, setRevealedSlots] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        setRevealedSlots([]);
        setActiveIndex(-1);
        setIsComplete(false);
    }, [draftOrder]);

    useEffect(() => {
        if (!draftOrder.length || isComplete) return undefined;

        if (activeIndex < 0) {
            const timer = setTimeout(() => setActiveIndex(0), 250);
            return () => clearTimeout(timer);
        }

        if (activeIndex >= draftOrder.length) {
            setIsComplete(true);
            return undefined;
        }

        const revealTimer = setTimeout(() => {
            const teamIndex = draftOrder[activeIndex];
            setRevealedSlots((prev) => [
                ...prev,
                {
                    pickNumber: activeIndex + 1,
                    teamIndex,
                    teamName: teamNames[teamIndex],
                },
            ]);
        }, REVEAL_MS);

        const nextTimer = setTimeout(() => {
            setActiveIndex((index) => index + 1);
        }, REVEAL_MS + GAP_MS);

        return () => {
            clearTimeout(revealTimer);
            clearTimeout(nextTimer);
        };
    }, [activeIndex, draftOrder, teamNames, isComplete]);

    const spotlightTeamIndex = activeIndex >= 0 && activeIndex < draftOrder.length
        ? draftOrder[activeIndex]
        : null;
    const spotlightTeamName = spotlightTeamIndex != null
        ? teamNames[spotlightTeamIndex]
        : null;

    return (
        <section className="draft-order-reveal">
            <div className="draft-order-reveal-header">
                <div className="draft-order-reveal-header-copy">
                    <h2>Draft Order</h2>
                    <p>Randomized pick order — same sequence every round.</p>
                </div>
                <div className="blind-draft-order-actions draft-order-reveal-actions">
                    <button type="button" className="blind-draft-secondary-btn" onClick={onBack}>
                        Back to Board
                    </button>
                    <button
                        type="button"
                        className="blind-draft-cta"
                        onClick={onBeginDraft}
                        disabled={!isComplete}
                    >
                        {isComplete ? "Start Draft" : "Revealing order…"}
                    </button>
                </div>
            </div>

            <div className="draft-order-reveal-stage">
                <div
                    key={activeIndex}
                    className={`draft-order-spotlight ${spotlightTeamName ? "is-live" : ""} ${isComplete ? "is-complete" : ""}`}
                >
                    {!isComplete && spotlightTeamName ? (
                        <>
                            <span className="draft-order-spotlight-label">Pick {activeIndex + 1}</span>
                            <strong className={spotlightTeamIndex === USER_TEAM_INDEX ? "is-user" : ""}>
                                {spotlightTeamName}
                            </strong>
                        </>
                    ) : (
                        <p className="draft-order-spotlight-done">Draft order locked in</p>
                    )}
                </div>

                <ol className="draft-order-reveal-list">
                    {revealedSlots.map((slot) => (
                        <li
                            key={slot.pickNumber}
                            className={`draft-order-reveal-item ${slot.teamIndex === USER_TEAM_INDEX ? "is-user" : ""}`}
                        >
                            <span className="draft-order-reveal-slot">{slot.pickNumber}</span>
                            <strong>{slot.teamName}</strong>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}

export default DraftOrderReveal;
